import currentUserService from "./currentUserService";

const $inject = ['$window', '$q', '$http', 'apiService', 'currentUserService'];

const userInfoService = function ($window, $q, $http, apiService, currentUserService) {
  let service = {};
  service.getInfo = getInfo;

  function getInfo() {
    const deferred = $q.defer();
    const apiUrl = apiService.getUrl('userInfo');

    $http.get(apiUrl, {apiVersion:20})
      .then((response) => {
        const { data } = response;
        currentUserService.store('userInfo', data);

        window.svelteStore.setTrackingIdentity(data.TravellerId);

        let [firstName, ...lastName] = data.Name.split(' ');
        lastName = lastName.join(' ');
        window.svelteStore.trackUser(firstName, lastName, data.Email, data.DebtorIdentifier);

        deferred.resolve(data);
      }).catch(() => {
        deferred.reject();
    });

    return deferred.promise;
  }

  return service;
};

userInfoService.$inject = $inject;

export default userInfoService;



// WEBPACK FOOTER //
// ./src/services/userInfoService.js